import React from "react";

interface Props {
  className?: string;
}

export const PlayIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="44"
      height="55"
      viewBox="0 0 44 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        d="M44 28.0548L8.34743e-06 55L0 27.6788L8.34743e-06 0L44 28.0548Z"
        fill="url(#paint0_radial)"
      />
      <defs>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.9339 27.7787) rotate(-40.5692) scale(25.054 30.513)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#4FFF80" />
        </radialGradient>
      </defs>
    </svg>
  );
};
